import React from "react";

export default function MySQL_RIGHT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_RIGHT</h1>
      <p>This is the MySQL_RIGHT component generated from the SQL JSON.</p>
    </div>
  );
}
